import React from "react";
import { useTranslation } from "react-i18next";
import { useRemoveMilestone } from "@planzone/view-models";
import { Modal } from "@common/modal";
import { Button } from "@common/button";
import { Props } from "./types";
import styles from "./styles.scss";

function MilestoneRemoval({ milestone, cancel }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, removeMilestone } = useRemoveMilestone(milestone);

  return (
    <Modal
      header={t("removeMilestone.title")}
      headerClassName={styles.header}
      close={cancel}
    >
      <div className={styles.main}>
        <div className={styles.group}>
          <p className={styles.text}>{t("removeMilestone.group")}</p>
          <p className={styles.name}>{`> ${milestone.name}`}</p>
          <p className={styles.text}>{t("removeMilestone.removal")}</p>
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("removeMilestone.cancel")}
          </Button>
          <Button
            type="delete"
            status={isRequestPending ? "pending" : "none"}
            press={() => removeMilestone(milestone)}
          >
            {t("removeMilestone.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { MilestoneRemoval };
